import { render, staticRenderFns } from "./tif.vue?vue&type=template&id=b6fb6e30"
import script from "./tif.vue?vue&type=script&lang=js"
export * from "./tif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports